import { render, staticRenderFns } from "./FlowOnlCgformHeadForm.vue?vue&type=template&id=48411426"
import script from "./FlowOnlCgformHeadForm.vue?vue&type=script&lang=js"
export * from "./FlowOnlCgformHeadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports